import { render, staticRenderFns } from "./StepBasicEditor.vue?vue&type=template&id=db8e47ac&scoped=true"
import script from "./StepBasicEditor.vue?vue&type=script&lang=js"
export * from "./StepBasicEditor.vue?vue&type=script&lang=js"
import style0 from "./StepBasicEditor.vue?vue&type=style&index=0&id=db8e47ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e47ac",
  null
  
)

export default component.exports